// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falXmark: CreateIconOptions = {
  "displayName": "FALXmark",
  "viewBox": "0, 0, 384, 512",
  "d": "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.6 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"
};
